import { getCurrentLocale } from '../../core/utils/locale.js'

import { errorFormResponsEvent, successFormResponsEvent } from './forms.analytics'

let isVerified = false

function formDataSubmit(form) {
  const submitButton = form.querySelector('.js-submit-button')
  submitButton.click()
}

function handlerSubmit(flashMessageAlert) {
  const emailInput = document.getElementById('email')
  const bookingInput = document.getElementById('booking_identifier')
  emailInput.addEventListener('change', function () {
    flashMessageAlert.classList.add('hidden')
  })
  bookingInput.addEventListener('change', function () {
    flashMessageAlert.classList.add('hidden')
  })
}

export function initCRMValidation() {
  const form = document.querySelector('.js-crm-form-validation')

  if (!form) {
    console.error('Formulario no encontrado')
    return
  }

  const clickButton = form.querySelector('.js-click-button')
  clickButton.addEventListener('click', function (event) {
    event.preventDefault()
    const isFormValid = $(form).parsley().validate()
    if (!isFormValid) {
      return
    }

    if (!isVerified) {
      isVerified = true
    } else {
      formDataSubmit(form)
      return
    }

    const flashMessageAlert = form.querySelector('.js-flash-alert-message')
    const flashMessageAlertText = flashMessageAlert.querySelector('.js-flash-message-text')
    const bookingIdentifier = document.getElementById('booking_identifier').value
    const email = document.getElementById('email').value
    const dataUserValidation = {
      bookingIdentifier,
      email,
    }
    const jsonDataUserValidation = JSON.stringify(dataUserValidation)
    const url = `/${getCurrentLocale()}/mail_contacts/verify_contact_form`

    fetch(url, {
      method: 'POST',
      body: jsonDataUserValidation,
      headers: {
        Accept: 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
      },
    })
      .then(response => {
        return response.json()
      })
      .then(data => {
        if (data.status === 200 || data.status === 'ok') {
          flashMessageAlert.classList.add('alert-success')
          flashMessageAlert.classList.remove('hidden')
          flashMessageAlertText.innerHTML = data.message
          // Función nueva de submit
          formDataSubmit(form)
          isVerified = false
          successFormResponsEvent(form)
        } else {
          errorFormResponsEvent(form)
          flashMessageAlert.classList.add('alert-danger')
          flashMessageAlert.classList.remove('hidden')
          flashMessageAlertText.innerHTML = data.message
          handlerSubmit(flashMessageAlert)
        }
      })
      .catch(error => {
        flashMessageAlert.classList.add('alert-danger')
        flashMessageAlert.classList.remove('hidden')
        flashMessageAlertText.innerHTML = error.message
        handlerSubmit(flashMessageAlert)
        errorFormResponsEvent(form)
      })
  })
}
